import { CreateElement } from "vue";
import i18n from "@/i18n";
import _ from "@/boot/lodash";
import store from "@/store";
import { DataModules } from "@/store/modules/data";
import { DefaultFilters as ClientsFilters } from "@/data/filters/client";
import { DefaultSorters as ClientsSorters } from "@/data/sorters/client";
import { IClient } from "@/models/clients";
import { IImportMappingSource } from "@/models/imports";

const getClientName = (client: IClient) => {
  return _.first(
    _.compact([
      _.trim(_.get(client, "fullname", "")),
      null,
      _.get(client, "is_guest") ? i18n.t("_.guest_client") : "",
      _.isEmpty(client) && client.id
        ? i18n.t("_.deleted_client")
        : i18n.t("_.guest")
    ])
  )?.toString();
};

const clientsWithParam = () => {
  return store.getters[`data/${DataModules.CLIENTS}/withParam`]();
};

const clientRoute = (client: IClient) => {
  return {
    name: "adminClient",
    params: {
      clientId: client.id
    }
  };
};

const firstLabel = (
  h: CreateElement,
  client: IClient,
  onClick: Function = () => ({})
) => {
  return h("p", {}, [
    h(
      "u-link",
      { props: { to: clientRoute(client) }, on: { click: onClick } },
      [h("strong", {}, getClientName(client))]
    )
  ]);
};

const secondLabel = (h: CreateElement, client: IClient) => {
  return h("p", { class: "is-size-8" }, [
    h("span", { class: "has-text-grey-light" }, client.email || "--")
  ]);
};

const media = (h: CreateElement, client: IClient) => {
  return h("avatar", {
    props: {
      size: 48,
      name: client.fullname,
      src: client.image_url || null,
      email: client.email
    }
  });
};

export const ClientSource: IImportMappingSource = {
  props: {
    availableFilters: ClientsFilters,
    availableSorters: ClientsSorters(),
    usedDataModule: DataModules.CLIENTS,
    guardFunctionalities: ["list_clients"],
    storeParams: querySearch => {
      return {
        with: clientsWithParam(),
        with_staged_imports: 1,
        ...(querySearch ? { query: querySearch } : {})
      };
    }
  },
  render: {
    id: client => client.id,
    firstLabel: (h: CreateElement, client: IClient, onClick: Function) =>
      firstLabel(h, client, onClick),
    secondLabel: (h: CreateElement, client: IClient) => secondLabel(h, client),
    media: (h: CreateElement, client: IClient) => media(h, client)
  }
};
